import { useEffect, useState } from 'react';

export const useImagePreloader = (imageUrls: string[], imagePreloader: (src: string[]) => Promise<unknown[]>) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    const safePreloadImages = async () => {
      const promises = await imagePreloader(imageUrls);
      try {
        await Promise.all(promises);
        if (isMounted) setIsLoaded(true);
      } catch (e) {
        if (isMounted) setError(e);
      }
    };

    safePreloadImages();

    return () => {
      setIsMounted(false);
    };
  }, [imageUrls, isMounted]);

  return { error, isLoaded };
};
